













































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getAssignedProducts, unlock, start } from '@/api/pickup';
import { removeFrontZone } from '@/utils/string';

interface ILockProduct {
  id: string; // item_number
  name: string; // item_name
  actualQty: number;
  expectedQty: number;
}

interface IProduct {
  id: string;
  item_name: string;
  item_number: string;
  active: boolean;
  actual_quantity: number;
  qty: number;
}

@Component({
  name: 'ProductChangeDialog',
})
export default class extends Vue {
  @Prop({ required: true }) private date!: string;

  @Prop({ required: true }) private locationCode!: string;

  @Prop({ required: true }) private lockProducts!: ILockProduct[];

  @Prop({ required: true }) private disabled!: boolean;

  @Prop({ default: () => '' }) private buttonClass!: string;

  @Watch('disabled')
  onChangeValue(newVal: boolean) {
    this.isDisabled = newVal;
  }

  private dialog = false;

  private products: IProduct[] = [];

  private selected: string[] = [];

  private isDisabled = false;

  private async openHandle() {
    this.$overlay(true);
    this.products = [];
    this.selected = [];
    const assignedProducts = await getAssignedProducts(this.date, this.locationCode);
    assignedProducts.forEach((product) => {
      this.products.push({
        id: product.id,
        item_name: product.item_name,
        item_number: product.item_number,
        active: false,
        actual_quantity: product.actual_quantity
          ? Number(product.actual_quantity)
          : Number(product.qty),
        qty: Number(product.qty),
      });
    });
    this.lockProducts.forEach((lockProduct: ILockProduct) => {
      this.products.unshift({
        id: lockProduct.id,
        item_name: lockProduct.name,
        item_number: lockProduct.id,
        active: true,
        actual_quantity: lockProduct.actualQty,
        qty: lockProduct.expectedQty,
      });
      this.selected.push(lockProduct.id);
    });
    this.$overlay(false);
    this.dialog = true;
  }

  private async saveHandle() {
    if (this.selected.length > 4) {
      this.$toast('最多只能选择 4 个物料', { color: 'red', icon: 'fas fa-info-circle' });
      return;
    }
    this.$confirm('Sure to replace?').then((result) => {
      if (result) {
        this.changeProduct();
      }
    });
  }

  private closeHandle() {
    this.dialog = false;
  }

  private async changeProduct() {
    const addItem: string[] = [];
    const removeItem: string[] = [];
    this.products.forEach((product: IProduct) => {
      if (this.selected.includes(product.item_number)) {
        if (!product.active) {
          addItem.push(product.item_number);
        }
      } else if (product.active) {
        removeItem.push(product.item_number);
      }
    });

    this.$overlay(true);
    if (removeItem.length > 0) {
      await unlock(this.date, this.locationCode, removeItem);
    }
    if (addItem.length > 0) {
      await start(this.date, this.locationCode, addItem);
    }
    this.$overlay(false);

    this.$emit('save');

    this.dialog = false;
  }

  private removeFrontZone(str: string) {
    return removeFrontZone(str);
  }
}
